// @flow weak
export const appConfig     = require('../../../appConfig');




// WEBPACK FOOTER //
// ./src/app/config/appConfig.js